module.exports = __webpack_public_path__ + "media/images/home/alarm-fc27f0668c2fffc78880d27d4a363d7e.svg";